import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

const SUPPORTED_LANGUAGES = ["es", "en", "pt-BR"] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const detectDefaultLanguage = (): SupportedLanguage => {
  try {
    const stored = window.localStorage.getItem("backoffice.preferences.language");
    if (stored && SUPPORTED_LANGUAGES.includes(stored as SupportedLanguage)) {
      return stored as SupportedLanguage;
    }
  } catch {
    // ignore
  }

  const system = navigator.language || navigator.languages?.[0] || "es";
  const normalized = system.toLowerCase();
  if (normalized.startsWith("pt")) return "pt-BR";
  if (normalized.startsWith("en")) return "en";
  return "es";
};

const defaultLanguage = detectDefaultLanguage();

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)
    )
  )
  .init({
    lng: defaultLanguage,
    fallbackLng: "es",
    debug: false,
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
  });

export default i18n;
